export default {"src":"/_next/static/media/Texas.d62f4a10.svg","height":650,"width":800,"blurWidth":0,"blurHeight":0};